import { Fragment } from 'react'

import { Divider } from '../../../Divider'
import { Skeleton } from '../../../Skeleton'
import { PROFILE_INFO_WIDGET_SKELETON_ROWS_COUNT } from '../ProfileInfoWidget.constants'

import * as styles from './ProfileInfoWidgetSkeleton.module.css'

function ProfileInfoWidgetSkeleton({
  className = styles.ProfileInfoWidgetSkeleton,
}) {
  return (
    <div className={className}>
      {Array.from({ length: PROFILE_INFO_WIDGET_SKELETON_ROWS_COUNT }).map(
        (_, index) => (
          <Fragment key={index}>
            {index > 0 ? <Divider className={styles.divider} /> : null}
            <div className={styles.item}>
              <Skeleton className={styles.label} />
              <div className={styles.value}>
                <Skeleton className={styles.valueBar} />
              </div>
            </div>
          </Fragment>
        )
      )}
    </div>
  )
}

export default ProfileInfoWidgetSkeleton
